module.exports = __webpack_public_path__ + "static/img/my-report.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/my-report.png
// module id = 578
// module chunks = 0